export default __webpack_public_path__ + "_/bpl-tools/Components/Mask/assets/shapes/sketch.svg";